export default __webpack_public_path__ + "static/media/tv.c952a945.png";